/**
 * App color facade. Values come from the Phone UI brand and alias tokens.
 * Numeric keys stay so existing screens can keep reading colors.yovoRed[400].
 */

import { brandColors } from './brand';
import { aliasColors } from './alias';

const colors = {
  yovoRed: {
    100: brandColors.primary.yovoRed100,
    200: brandColors.primary.yovoRed200,
    300: brandColors.primary.yovoRed300,
    400: brandColors.primary.yovoRed400,
    500: brandColors.primary.yovoRed500,
  },
  secondary: {
    100: brandColors.secondary.secondary100,
    200: brandColors.secondary.secondary200,
    300: brandColors.secondary.secondary300,
    400: brandColors.secondary.secondary400,
    500: brandColors.secondary.secondary500,
  },
  tertiary: {
    50: brandColors.tertiary.tertiary50,
    100: brandColors.tertiary.tertiary50,
    200: brandColors.tertiary.tertiary200,
    300: brandColors.tertiary.secondary200,
    400: brandColors.tertiary.secondary400,
  },
  accent: {
    100: brandColors.accents.accents100,
    200: brandColors.accents.accents200,
    300: brandColors.accents.accents300,
  },
  background: {
    bg01: aliasColors.background.bg01,
    bg02: aliasColors.background.bg02,
    bg03: aliasColors.background.bg03,
    bg04: aliasColors.background.bg04,
  },
  divider: {
    d01: aliasColors.divider.divider01,
    d02: aliasColors.divider.divider02,
    d03: aliasColors.divider.divider03,
    d04: aliasColors.divider.divider04,
  },
  neutral: {
    white: brandColors.neutrals.baseWhite,
    100: brandColors.neutrals.grey100,
    200: brandColors.neutrals.grey200,
    300: brandColors.neutrals.grey300,
    400: brandColors.neutrals.grey400,
    500: brandColors.neutrals.grey500,
    600: brandColors.neutrals.grey600,
    700: brandColors.neutrals.grey700,
    800: brandColors.neutrals.grey800,
    900: brandColors.neutrals.grey900,
    1000: brandColors.neutrals.base1000,
    black: brandColors.neutrals.baseBlack,
  },
  semantic: {
    green: {
      100: brandColors.semantic.green100,
      200: brandColors.semantic.green200,
      300: brandColors.semantic.green300,
      400: brandColors.semantic.green400,
    },
    yellow: {
      100: brandColors.semantic.yellow100,
      200: brandColors.semantic.yellow200,
      300: brandColors.semantic.yellow300,
      400: brandColors.semantic.yellow400,
    },
    red: {
      100: brandColors.semantic.red100,
      200: brandColors.semantic.red200,
      300: brandColors.semantic.red300,
      400: brandColors.semantic.red400,
    },
  },
};

/** MUI palette mapping built from design tokens */
export const palette = {
  primary: {
    main: colors.neutral[1000],
    light: colors.neutral[900],
    dark: colors.neutral.black,
    contrastText: colors.neutral.white,
  },
  secondary: {
    main: colors.secondary[500],
    light: colors.secondary[200],
    dark: colors.secondary[400],
    contrastText: colors.neutral.white,
  },
  error: {
    main: colors.semantic.red[300],
    light: colors.semantic.red[100],
    dark: colors.semantic.red[400],
    contrastText: colors.neutral.white,
  },
  warning: {
    main: colors.semantic.yellow[300],
    light: colors.semantic.yellow[100],
    dark: colors.semantic.yellow[400],
    contrastText: colors.neutral.black,
  },
  success: {
    main: colors.semantic.green[300],
    light: colors.semantic.green[100],
    dark: colors.semantic.green[400],
    contrastText: colors.neutral.white,
  },
  info: {
    main: colors.tertiary[400],
    light: colors.tertiary[100],
    dark: colors.tertiary[300],
    contrastText: colors.neutral.white,
  },
  text: {
    primary: colors.neutral[900],
    secondary: colors.neutral[600],
    disabled: colors.neutral[500],
  },
  background: {
    default: colors.background.bg02,
    paper: colors.neutral.white,
  },
  divider: colors.divider.d04,
  /** Extended tokens accessible via theme.palette.tokens */
  tokens: colors,
};

export default colors;
